import Settings from './Settings.container';

export * from './+store';

export default Settings;
